import apiClient from './apiClient';

const handleError = (error) => {
  const message =
    error.response?.data?.error?.message ||
    error.response?.data?.message ||
    error.message;
  return message ? new Error(message) : error;
};

// List the users a support agent may impersonate (active employees/customers).
export const listUsers = async ({ search = '', page = 1, limit = 25 } = {}) => {
  try {
    const response = await apiClient.get('/support/users', { params: { search, page, limit } });
    return response.data.data; // { users, total, page, totalPages }
  } catch (error) {
    throw handleError(error);
  }
};

// Mint a scoped impersonation token for the given user id.
export const impersonate = async (userId) => {
  try {
    const response = await apiClient.post('/support/impersonate', { userId });
    return response.data.data; // { token, user, actingAs }
  } catch (error) {
    throw handleError(error);
  }
};

// Record the end of an impersonation session (audit trail). Best-effort.
export const stopImpersonation = async (userId) => {
  try {
    const response = await apiClient.post('/support/impersonate/stop', { userId });
    return response.data.data;
  } catch (error) {
    throw handleError(error);
  }
};

const supportService = { listUsers, impersonate, stopImpersonation };
export default supportService;
